import React from 'react';
import LoadingSkeleton from 'components/LoadingSkeleton';

const CoachLoggedInScreenSkeleton = () => {
  return (
    <div className="container mx-auto pt-8 max-sm:px-4">
      {/* Title skeleton */}
      <LoadingSkeleton count={1} height={32} width={220} className="mb-4" />
      {/* Subtitle skeleton */}
      <LoadingSkeleton count={1} height={20} width={160} className="mb-8" />
      {/* Card skeletons */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <LoadingSkeleton count={1} height={120} className="mb-2" />
          <LoadingSkeleton count={1} height={20} width={100} />
        </div>
        <div>
          <LoadingSkeleton count={1} height={120} className="mb-2" />
          <LoadingSkeleton count={1} height={20} width={100} />
        </div>
      </div>
    </div>
  );
};

export default CoachLoggedInScreenSkeleton;
